import { DownloadOutlined } from "@ant-design/icons";
import { Button } from "antd";

export function DetailsFiles({ entidade }) {
  return (
    <>
      <div className="ant-descriptions-title">Anexos</div>

      <span>Identidade funcional: </span>
      <Button
        onClick={() => {
          //console.log(entidade.anexoAtestadoAntecedente.split(",")[1])
          let pdfWindow = window.open("");
          pdfWindow.document.write(
            "<iframe width='100%' height='100%' src='" +
              encodeURI(entidade.anexoIdentidadeFuncional) +
              "'></iframe>"
          );
        }}
        icon={<DownloadOutlined />}
      >
        Download
      </Button>
      <br />
      {/*
      <span>Atestado de Antecedentes Criminais da SSPDS-CE: </span>
      <Button
        onClick={() => {
          let pdfWindow = window.open("");
          pdfWindow.document.write(
            "<iframe width='100%' height='100%' src='" +
              encodeURI(entidade.anexoAtestadoAntecedente) +
              "'></iframe>"
          );
        }}
        icon={<DownloadOutlined />}
      >
        Download
      </Button>
      <br /> */}
      {entidade.anexoCertidaoCGD && (
        <>
          <span>{"Certidão disciplinar CGD/Ofício de Solicitação"}: </span>
          <Button
            onClick={() => {
              let pdfWindow = window.open("");
              pdfWindow.document.write(
                "<iframe width='100%' height='100%' src='" +
                  encodeURI(entidade.anexoCertidaoCGD) +
                  "'></iframe>"
              );
            }}
            icon={<DownloadOutlined />}
          >
            Download
          </Button>
          <br />
        </>
      )}
      {entidade.anexoTermoConvenio && (
        <>
          <span>{"Termo de cooperação/Convênio"}: </span>
          <Button
            onClick={() => {
              let pdfWindow = window.open("");
              pdfWindow.document.write(
                "<iframe width='100%' height='100%' src='" +
                  encodeURI(entidade.anexoTermoConvenio) +
                  "'></iframe>"
              );
            }}
            icon={<DownloadOutlined />}
          >
            Download
          </Button>
          <br />
        </>
      )}

      {/* <span>Certidão criminal do TJCE, 1º instância: </span>
      <Button
        onClick={() => {
          let pdfWindow = window.open("");
          pdfWindow.document.write(
            "<iframe width='100%' height='100%' src='" +
              encodeURI(entidade.anexocertidaoForumTJCE) +
              "'></iframe>"
          );
        }}
        icon={<DownloadOutlined />}
      >
        Download
      </Button>

      <br />

      <span>Certidão criminal do TJCE 2º instância: </span>
      <Button
        onClick={() => {
          let pdfWindow = window.open("");
          pdfWindow.document.write(
            "<iframe width='100%' height='100%' src='" +
              encodeURI(entidade.anexocertidaoForumTJCE2) +
              "'></iframe>"
          );
        }}
        icon={<DownloadOutlined />}
      >
        Download
      </Button> */}
    </>
  );
}
